<template>
  <div class="mx-auto w-100 w-md-80">

    <amio-header></amio-header>

    <div class="row mx-0 mt-4 mt-sm-6 mt-md-7">
      <div class="col-12 col-md-5 d-flex align-items-center px-4 px-md-0">
        <div>
          <h1>
            Looking for a change?<br/>
            <span class="font-weight-bold">
              Join us
            </span>
          </h1>
        </div>
      </div>

      <div class="col-12 col-md-6 d-flex mt-0 mt-sm-6 mt-md-0 px-0 px-sm-5 pl-md-4 pr-md-0">
        <iframe border="0" height="54px" id="sj-offers-banner" scrolling="no" src="https://www.startupjobs.cz/en/startup/amio?embedded=2" style="min-height:54px;border:0;width:100%;" width="100%"></iframe>
        <script type="application/javascript" src="https://www.startupjobs.cz/front/web/components/embedding/embedding2.min.js"></script>
      </div>
    </div>

    <customer-references class="mt-md-6 d-none d-md-flex"/>

    <amio-footer class="mt-5 pt-7"></amio-footer>
  </div>
</template>

<script>
  import AmioFooter from '@/components/common/AmioFooter'
  import AmioHeader from '@/components/common/AmioHeader'
  import CustomerReferences from '@/components/common/CustomerReferences'

  export default {
    components: {
      AmioFooter,
      AmioHeader,
      CustomerReferences
    }
  }
</script>
